import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import parts from '@/components/parts'
import sets from '@/components/sets'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'Login',
    title: 'Brickfinder',
    component: login,
    meta: {
      noAuth: true
    },
    props: true
  }, {
    path: '/sets',
    name: 'Sets',
    title: 'Brickfinder - Sets',
    component: sets,
    meta: {
      sort_menu: [{
        label: "Set Number",
        value: "default"
      }, {
        label: "Missing",
        value: "missing"
      }, {
        label: "Completeness",
        value: "completeness"
      }, {
        label: "Incompleteness",
        value: "incompleteness"
      }, {
        label: "Name",
        value: "name"
      }, {
        label: "Year",
        value: "year"
      }, {
        label: "Theme",
        value: "theme"
      }, {
        label: "Part Count",
        value: "parts"
      }]
      /*menu: [{
          label: "Restore Set",
          icon: "unarchive"
      }]*/
    }
  }, {
    path: '/sets/:set',
    name: 'Parts',
    title: 'Brickfinder - Parts',
    component: parts,
    meta: {
      parent: 'Sets',
      sort_menu: [{
        label: "Set Order",
        value: "default"
      }, {
        label: "Missing",
        value: "missing"
      }, {
        label: "Completeness",
        value: "completeness"
      }, {
        label: "Incompleteness",
        value: "incompleteness"
      }, {
        label: "Name",
        value: "name"
      }, {
        label: "Category",
        value: "category"
      }, {
        label: "Colour",
        value: "color"
      }],
      menu: [{
        label: "Back",
        icon: "arrow_back"
      }, {
        type: "divider"
      }, {
        label: "Complete",
        icon: "done_all"
      }, {
        label: "Reset",
        icon: "settings_backup_restore"
      }, {
        label: "Archive",
        icon: "archive"
      }, {
        label: "Delete",
        icon: "delete"
      }]
    }

  }, ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js